// extracted by mini-css-extract-plugin
export var card = "links-rotating-background-module--card--833f6";
export var cardText = "links-rotating-background-module--card-text--99142";
export var expandIn = "links-rotating-background-module--expand-in--0966d";